import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  FlatList,
  TextInput,
} from "react-native";
import Header from "../../../component/header";
import Background from "../../../component/background";
import PrelimDetail from "../../../component/prelimDetail";
import {
  approbationscheck,
  approbationsdeletecheck,
} from "../../../action/authAction";
import { useRecoilValue } from "recoil";
import { tokenState } from "../../../reducer/recoil";
const { width, height } = Dimensions.get("window");
export default function index({ navigation, route }) {
  const token = useRecoilValue(tokenState);
  const approbation_details = route.params.approbation_details;
  const events_female = route.params.events_female;
  const events_male = route.params.events_male;

  console.log("route.params >> ", route.params.approbation_id);

  async function callApi() {
    const response = await approbationscheck({
      body: {
        approbation_id: route.params.approbation_id,
        approbation_status: "Approved",
      },
      token: token.token,
    });
    if (response) {
      navigation.goBack();
    }
  }

  async function CancelcallApi() {
    const response = await approbationscheck({
      body: {
        approbation_id: route.params.approbation_id,
        approbation_status: "Pending",
      },
      token: token.token,
    });
    if (response) {
      navigation.goBack();
    }
  }

  async function CancelcallApi1() {
    const response = await approbationsdeletecheck({
      body: {
        approbation_id: route.params.approbation_id,
      },
      token: token.token,
    });
    if (response) {
      navigation.goBack();
    }
  }

  return (
    <View style={styles.container}>
      <Header
        backgroundColorCompetition="#FFFFFF"
        Admin
        navigation={navigation}
      />
      <ScrollView>
        <View>
          <Background
            navigation={navigation}
            Title={`COMPETITION/${route.params.name}/COUNTRIES STATUS`}
            admin
          />
          <View
            style={
              width >= 1280 ? styles.viewDetail : stylesResponsive.viewDetail
            }
          >
            <PrelimDetail
              approbation_details={approbation_details}
              events_male={events_male}
              events_female={events_female}
            />
            {route.params.approbation_status == "Pending" ? (
              <View
                style={{
                  flexDirection: "row",
                  marginTop: 43,
                  alignSelf: "center",
                }}
              >
                <TouchableOpacity
                  onPress={() => {
                    callApi();
                  }}
                  style={styles.buttonConfirm}
                >
                  <Text style={[styles.textbutton, { color: "#2BB165" }]}>
                    CONFIRM
                  </Text>
                </TouchableOpacity>
                <TouchableOpacity
                  onPress={() => {
                    CancelcallApi();
                    CancelcallApi1();
                  }}
                  style={styles.buttonCancel}
                >
                  <Text style={[styles.textbutton, { color: "#FF4E4E" }]}>
                    CANCEL
                  </Text>
                </TouchableOpacity>
              </View>
            ) : (
              <View
                style={{
                  flexDirection: "row",
                  marginTop: 43,
                  alignSelf: "center",
                }}
              >
                <TouchableOpacity
                  onPress={() => {
                    CancelcallApi();
                    CancelcallApi1();
                  }}
                  style={[styles.buttonCancel, { marginRight: 25 }]}
                >
                  <Text style={[styles.textbutton, { color: "#FF4E4E" }]}>
                    CANCEL
                  </Text>
                </TouchableOpacity>
                <TouchableOpacity
                  onPress={() => {
                    // callApi();
                    navigation.goBack();
                  }}
                  style={styles.buttonConfirm}
                >
                  <Text style={[styles.textbutton, { color: "#2BB165" }]}>
                    OK
                  </Text>
                </TouchableOpacity>
              </View>
            )}
          </View>
        </View>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#CCE4FF",
    flexDirection: "row",
  },
  viewDetail: {
    width: "95%",
    backgroundColor: "#FFFFFF",
    alignSelf: "center",
    marginVertical: 36,
    borderRadius: 46,
    paddingHorizontal: 45,
    paddingVertical: 39,
  },
  textTitle: {
    fontSize: 20,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  textDetail: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  detailNumber: {
    marginHorizontal: width * 0.05,
    width: width * 0.015,
    textAlign: "center",
  },
  textNumber: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginLeft: 10,
  },
  buttonConfirm: {
    width: 108,
    height: 43,
    backgroundColor: "#B2FFAC",
    borderWidth: 1,
    borderColor: "#2BB165",
    justifyContent: "center",
    borderRadius: 10,
  },
  textbutton: {
    fontSize: 14,
    fontFamily: "Prompt",
    alignSelf: "center",
  },
  buttonCancel: {
    width: 108,
    height: 43,
    backgroundColor: "#FFBEBE",
    borderWidth: 1,
    borderColor: "#FF4E4E",
    justifyContent: "center",
    marginLeft: 35,
    borderRadius: 10,
  },
});
const stylesResponsive = StyleSheet.create({
  viewDetail: {
    width: "90%",
    backgroundColor: "#FFFFFF",
    alignSelf: "center",
    marginVertical: 36,
    borderRadius: 46,
    paddingHorizontal: 45,
    paddingVertical: 39,
  },
});
